import { Component, Input, OnChanges } from "@angular/core";

export interface AllocRiskRow {
  label: string;
  allocation: number;
  risk: number;
}

@Component({
  selector: "app-alloc-risk-bars",
  standalone: true,
  imports: [],
  template: `
    <div class="alloc-risk">
      <div
        class="gbar-row header"
        style="font-size:10.5px; color: var(--text-dim); text-transform:uppercase; letter-spacing:0.05em;"
      >
        <div></div>
        <div>Allocation</div>
        <div>Risk contribution</div>
      </div>
      @for (r of rows; track r.label) {
        <div class="gbar-row">
          <div class="gb-label">{{ r.label }}</div>
          <div class="gb-cell">
            <div
              class="gb-bar"
              [style.width.%]="pct(r.allocation)"
              style="background: linear-gradient(90deg, #54C7FF, #7C5CFF);"
            ></div>
            <div class="gb-val">{{ fmt(r.allocation) }}</div>
          </div>
          <div class="gb-cell">
            <div
              class="gb-bar"
              [style.width.%]="pct(r.risk)"
              style="background: linear-gradient(90deg, #FFB547, #FF5C7A);"
            ></div>
            <div class="gb-val">{{ fmt(r.risk) }}</div>
          </div>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .alloc-risk .gbar-row {
        grid-template-columns: 110px 1fr 1fr;
      }
      .alloc-risk .gb-bar {
        max-width: calc(100% - 54px);
        min-width: 2px;
      }
    `,
  ],
})
export class AllocRiskBarsComponent implements OnChanges {
  @Input() rows: AllocRiskRow[] = [];
  @Input() format: (v: number) => string = (v) => (v * 100).toFixed(1) + "%";

  maxAlloc = 1;
  maxRisk = 1;

  ngOnChanges(): void {
    this.maxAlloc = Math.max(
      ...this.rows.map((r) => Math.abs(r.allocation)),
      0.0001,
    );
    this.maxRisk = Math.max(...this.rows.map((r) => Math.abs(r.risk)), 0.0001);
  }

  pct(v: number): number {
    const max = Math.max(this.maxAlloc, this.maxRisk);
    return Math.min(100, (Math.abs(v) / max) * 100);
  }

  fmt(v: number): string {
    return this.format(v);
  }
}
